module.exports = __webpack_public_path__ + "img/kommune-929.49a9ccdb.svg";